const SidebarSeparator = ({styles, additionalClasses}) => {
  return <span className={`sidebar-separator ${additionalClasses}`} style={{...styles}} />;
};

export default SidebarSeparator;
